import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Stack,
  CircularProgress,
  Modal,
} from "@mui/material";
import { useState } from "react";
import ScrollableTable from "./ScrollableTable";
import { useUser } from "../Contexts/UserContext";
import EnhancedTable from "./EnhancedTable";
import getTodayDate from "./TodaysDate";
import Table from "./Table";
import Table2 from "./Table2";
import DynamicTable from "./DynamicTable";
import EnhancedTable2 from "./EnhancedTable2";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const unitData = [
  { UnitCode: "U001", UnitName: "Unit One" },
  { UnitCode: "U002", UnitName: "Unit Two" },
  { UnitCode: "U003", UnitName: "Unit Three" },
  { UnitCode: "U001", UnitName: "Unit One" },
  { UnitCode: "U002", UnitName: "Unit Two" },
  { UnitCode: "U003", UnitName: "Unit Three" },
  { UnitCode: "U001", UnitName: "Unit One" },
  { UnitCode: "U002", UnitName: "Unit Two" },
  { UnitCode: "U003", UnitName: "Unit Three" },
  // Add more rows as needed
];
const columns = [
  // { id: "AttendanceDate", label: "Date" },
  { id: "Empcode", label: "EmpCode", idx: 0 },
  { id: "EmpName", label: "EmpName", idx: 1 },
  { id: "LoginTime", label: "LOGINTIME", idx: 2 },
  { id: "LogoutTime", label: "LOGOUTTIME", idx: 3 },
];
const columns2 = [
  // { id: "AttendanceDate", label: "Date" },
  { id: "UnitCode", label: "Unit Code", idx: 0 },
  { id: "UnitName", label: "Unit Name", idx: 1 },
  { id: "EmpCode", label: "EmpCode", idx: 2 },
  { id: "EmpName", label: "EmpName", idx: 3 },
  { id: "OpeningTime", label: "OpeningTime", idx: 4 },
  { id: "ClosingTime", label: "ClosingTime", idx: 5 },
];
const StatsCard = ({ title, subtitle, number, classNames, activeBtn }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const { ClientId, CompCode } = user;

  const handleOpen = () => {
    setOpen(true);
    fetchData();
  };
  const helper = () => {
    if (classNames === "c1") {
      // return <ScrollableTable data={data} />;
      return <DynamicTable data={data} />;
    } else if (classNames === "pest") {
      return ClientId == "11613" || ClientId == "11621" ? (
        <Table2 data={data} itemsPerPage={10} />
      ) : (
        <Table data={data} itemsPerPage={10} />
      );
    } else if (classNames === "deep") {
      return ClientId == "11542" ? (
        <Table data={data} itemsPerPage={10} />
      ) : (
        <Table2 data={data} itemsPerPage={10} />
      );
    } else if (classNames === "washroom") {
      return ClientId == "11542" ? (
        <Table data={data} itemsPerPage={10} />
      ) : (
        <Table2 data={data} itemsPerPage={10} />
      );
    } else if (classNames === "material") {
      return <Table2 data={data} itemsPerPage={10} />;
    } else if (classNames === "sitesOpen") {
      return <EnhancedTable2 columns={columns2} data={data} />;
    } else if (classNames === "dailyCleaning") {
      return <Table2 data={data} itemsPerPage={10} />;
    } else if (classNames === "pestRpt") {
      return <Table2 data={data} itemsPerPage={10} />;
    } else if (classNames === "foVisit") {
      return <Table2 data={data} itemsPerPage={10} />;
    } else if (classNames === "thermo") {
      return <Table2 data={data} itemsPerPage={10} />;
    } else {
      return <EnhancedTable columns={columns} data={data} />;
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      //   const response = await axios.get("https://api.example.com/data"); // Replace with your API URL
      if (classNames === "c1") {
        const res = await fetch(
          `${API_URL}/facility/get-client-all-unit/1/${ClientId}/0`
        ).then((res) => res.json());
        setData(res.data.units);
      } else if (classNames === "pest") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/${
            ClientId == "11613" || ClientId == "11621" ? 6 : 3
          }/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "deep") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/2/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "material") {
        const res = await fetch(
          `${API_URL}/facility/get-login-logout-times/0/${CompCode}/${ClientId}/UNTAPS009554/3/2024-07-03/2024-07-03`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "washroom") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/4/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "sitesOpen") {
        const res = await fetch(
          `https://www.apsgroupapp.com/ExpressAPI/facility/getFacilityReport?action=getClientUnitOpenCloseData&clientCode=${ClientId}&fromDate=NA&toDate=NA&unitCode=0`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "dailyCleaning") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/7/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "pestRpt") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/8/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "foVisit") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/9/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else if (classNames === "thermo") {
        const res = await fetch(
          `${API_URL}/facility/get-facility-cards-data/10/${CompCode}/${ClientId}/:fromDate/:toDate`
        ).then((res) => res.json());
        setData(res.data);
      } else {
        const res = await fetch(
          `${API_URL}/facility/get-login-logout-times/1/${CompCode}/${ClientId}/UNTAPS009554/0/${getTodayDate()}/${getTodayDate()}`
        ).then((res) => res.json());
        setData(res.data);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  return (
    <Card
      sx={{
        minWidth: 200,
        width: 200,
        maxWidth: 250,
        boxShadow: 3,
        borderRadius: 2,
        height: 141,
      }}
      className={`${classNames}`}
    >
      <CardContent>
        <Typography
          sx={
            title.length < 15
              ? {
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "500",
                  padding: "0",
                  lineHeight: "25px",
                  margin: "0px 0px 0px 0vw",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  fontFamily: "Poppins, sans-serif",
                }
              : {
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "500",
                  padding: "0",
                  lineHeight: "25px",
                  margin: "0px 0px 0px 0vw",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  fontFamily: "Poppins, sans-serif",
                }
          }
          // color="text.secondary"
          color="#fff"
          gutterBottom
        >
          {title}
        </Typography>
        <Typography variant="h3" component="div">
          {number}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Typography
            sx={{
              color: "#67737B",
              margin: "0px 0px 0px 0px",
              fontWeight: "700",
              fontSize: "14px",
              fontFamily: "Share Tech Mono",
              // eslint-disable-next-line
              fontFamily: "monospace",
            }}
            color="text.secondary"
          >
            {subtitle}
          </Typography>
          {activeBtn && (
            <Button
              size="small"
              variant="outlined"
              sx={{
                height: "20px",
                color: "#fff",
                fontSize: "10px",
                width: "1px",
                marginRight: "10px",
              }}
              onClick={handleOpen}
            >
              view
            </Button>
          )}
        </Stack>
      </CardContent>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            width: 800,
            bgcolor: "background.paper",
            // border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : data ? (
            helper()
          ) : (
            "No data available"
          )}
        </Box>
      </Modal>
    </Card>
  );
};

export default StatsCard;
